query company($id: String) {
  company(id: $id) {
    id
    deleteOn
  }
}
